const KEY = 'STATIC.PAGES.FRAUD.SETTINGS';

export const ACTION_VALUES = {
    SUSPICIOUS: 1,
    REJECT: 0,
    DO_NOTHING: -1,
};

export const DEFAULT_ACTION = ACTION_VALUES.SUSPICIOUS;

export const ACTION_OPTIONS = [
    { value: ACTION_VALUES.SUSPICIOUS, label: `${KEY}.ACTIONS.MARK_SUSPICIOUS` },
    { value: ACTION_VALUES.REJECT, label: `${KEY}.ACTIONS.REJECT` },
    { value: ACTION_VALUES.DO_NOTHING, label: `${KEY}.ACTIONS.DO_NOTHING` },
];

export const ACTION_OPTIONS_NO_REJECT = ACTION_OPTIONS.filter(opt => opt.value !== ACTION_VALUES.REJECT);

export const SETTING_IDS = {
    TTI_OUTLIER: 'tti_outlier',
    BLACKLISTED_IPS: 'blacklisted_ips',
    BLACKLISTED_PUBLISHERS: 'blacklisted_publishers',
    DUPLICATE_CLICKS: 'duplicate_clicks',
    GEO_BLEED: 'geo_bleed',
    RECEIPT_VALIDATION: 'receipt_validation',
    ANDROID_INSTALL_VALIDATION: 'android_install_validation',
    CLICK_HIJACKING: 'click_hijacking',
};

export const SETTINGS = [
    {
        id: SETTING_IDS.TTI_OUTLIER,
        nameKey: `${KEY}.ITEMS.TTI_OUTLIER.NAME`,
        descriptionKey: `${KEY}.ITEMS.TTI_OUTLIER.DESCRIPTION`,
        exampleKeys: [`${KEY}.ITEMS.TTI_OUTLIER.EXAMPLE`],
        default: DEFAULT_ACTION,
        visible: true,
        noReject: false,
    },
    {
        id: SETTING_IDS.BLACKLISTED_IPS,
        nameKey: `${KEY}.ITEMS.BLACKLISTED_IPS.NAME`,
        descriptionKey: `${KEY}.ITEMS.BLACKLISTED_IPS.DESCRIPTION`,
        exampleKeys: [`${KEY}.ITEMS.BLACKLISTED_IPS.EXAMPLE`],
        default: DEFAULT_ACTION,
        visible: true,
        noReject: false,
    },
    {
        id: SETTING_IDS.BLACKLISTED_PUBLISHERS,
        nameKey: `${KEY}.ITEMS.BLACKLISTED_PUBLISHERS.NAME`,
        descriptionKey: `${KEY}.ITEMS.BLACKLISTED_PUBLISHERS.DESCRIPTION`,
        exampleKeys: [`${KEY}.ITEMS.BLACKLISTED_PUBLISHERS.EXAMPLE`],
        default: DEFAULT_ACTION,
        visible: false,
        noReject: false,
    },
    {
        id: SETTING_IDS.DUPLICATE_CLICKS,
        nameKey: `${KEY}.ITEMS.DUPLICATE_CLICKS.NAME`,
        descriptionKey: `${KEY}.ITEMS.DUPLICATE_CLICKS.DESCRIPTION`,
        exampleKeys: [`${KEY}.ITEMS.DUPLICATE_CLICKS.EXAMPLE`],
        default: DEFAULT_ACTION,
        visible: true,
        noReject: false,
    },
    {
        id: SETTING_IDS.GEO_BLEED,
        nameKey: `${KEY}.ITEMS.GEO_BLEED.NAME`,
        descriptionKey: `${KEY}.ITEMS.GEO_BLEED.DESCRIPTION`,
        exampleKeys: [`${KEY}.ITEMS.GEO_BLEED.EXAMPLE`],
        default: DEFAULT_ACTION,
        visible: true,
        noReject: false,
    },
    {
        id: SETTING_IDS.RECEIPT_VALIDATION,
        nameKey: `${KEY}.ITEMS.RECEIPT_VALIDATION.NAME`,
        descriptionKey: `${KEY}.ITEMS.RECEIPT_VALIDATION.DESCRIPTION`,
        exampleKeys: [`${KEY}.ITEMS.RECEIPT_VALIDATION.EXAMPLE`],
        default: DEFAULT_ACTION,
        visible: true,
        noReject: false,
    },
    {
        id: SETTING_IDS.ANDROID_INSTALL_VALIDATION,
        nameKey: `${KEY}.ITEMS.ANDROID_INSTALL_VALIDATION.NAME`,
        descriptionKey: `${KEY}.ITEMS.ANDROID_INSTALL_VALIDATION.DESCRIPTION`,
        exampleKeys: [`${KEY}.ITEMS.ANDROID_INSTALL_VALIDATION.EXAMPLE`],
        default: DEFAULT_ACTION,
        visible: false,
        noReject: false,
    },
    {
        id: SETTING_IDS.CLICK_HIJACKING,
        nameKey: `${KEY}.ITEMS.CLICK_HIJACKING.NAME`,
        descriptionKey: `${KEY}.ITEMS.CLICK_HIJACKING.DESCRIPTION`,
        exampleKeys: [`${KEY}.ITEMS.CLICK_HIJACKING.EXAMPLE`],
        default: DEFAULT_ACTION,
        visible: false,
        noReject: false,
    },
];

export const FAQ_LINK = 'https://support.singular.net/hc/en-us/articles/360003142231-Configuring-Fraud-Settings';

export const TRANSLATION_KEY = KEY;
